import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../services/api';
import '../../components/admin/AdminLayout.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/admin/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-loading">Loading dashboard...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-stats-grid">
        <div className="admin-stat-card highlight">
          <div className="admin-stat-value">{stats?.users?.total || 0}</div>
          <div className="admin-stat-label">Total Users</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.users?.premium || 0}</div>
          <div className="admin-stat-label">Premium Users</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.users?.free || 0}</div>
          <div className="admin-stat-label">Free Users</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.users?.promoters || 0}</div>
          <div className="admin-stat-label">Promoters</div>
        </div>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.documents?.total || 0}</div>
          <div className="admin-stat-label">Total Documents</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.documents?.bills || 0}</div>
          <div className="admin-stat-label">Bills of Sale</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.documents?.invoices || 0}</div>
          <div className="admin-stat-label">Invoices</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.users?.activeToday || 0}</div>
          <div className="admin-stat-label">Active Today</div>
        </div>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.users?.newThisMonth || 0}</div>
          <div className="admin-stat-label">New Users (30 days)</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-value">{stats?.users?.suspended || 0}</div>
          <div className="admin-stat-label">Suspended</div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
